import styled from 'styled-components';

import { Filter, Input } from 'components/shared/filter';

export const SignalsHistoryFilterBox = styled(Filter)`
  height: 120px;
`;
export const DescriptionInput = styled(Input)`
  width: 250px;
`;
export const NumberInput = styled(Input)`
  width: 55px;
`;
